import React, { useContext, useRef } from "react";
import { PivotControls, useGLTF } from "@react-three/drei";
import * as THREE from "three";
import { useControls } from "leva";
import { ThreeContext } from "./Context";

export default function Pergolas(props) {

  const {data, Position, Rotation, Modele} = props; // Get JSON Data  
  const {debug} = useContext(ThreeContext); // Get Context
  const { nodes, materials } = useGLTF(`./Models/Pergolas/${Modele}.glb`);

  const Metal = new THREE.MeshStandardMaterial({ color: "#aaaaaa", metalness : 0.7, roughness : 0.1, envMapIntensity : 1});

  return (
    <PivotControls anchor={[0, 0, 0]} activeAxes={[debug, debug, debug]} visible={debug} depthTest={false}>
      <group position={Position} rotation={Rotation} scale={3} dispose={null}>
        <group position={[0.3, 1.8, -1]} rotation={[Math.PI / 2, 0, 0]}>
          <mesh
            castShadow
            receiveShadow 
            geometry={nodes['Item'].geometry}
            material={materials.WOOD}
          />
          <mesh
            geometry={nodes['Item_1'].geometry}
            material={Metal}
          />
        </group>
      </group>
    </PivotControls>
  );
}

useGLTF.preload("./Models/Pergolas/Asymetrique XL.glb");
